setTimeout(function () {
  // let statusPartials = document.querySelector('a.statusPartials');
  // statusPartials && statusPartials.click();
  // console.log('Clicou');
}, 2000);